module.exports = __webpack_public_path__ + "static/month-quarter-end-64c7be605ffafcc7e09dbe1046d1baa7.svg";